import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";
import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";

interface CustomCSS {
    enable?: boolean;
    parsedValue?: string;
    rawValue?: string;
}
/**
 * @title Custom CSS Configuration
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.CustomCSS)
@ComponentConfigurationClass("customCSSConfiguration")
export class CustomCSSConfiguration {
    /**
     * @title Use custom CSS
     * @format custom-css
     */
    public customCSS?: CustomCSS;
}
